import React, { Component } from 'react';
import { withRouter } from "react-router";
import AppContext from '../../AppContext'

import { withTranslation } from 'react-i18next';

import styles from '../../styles/toggleAudio.module.css';


class ToggleAudio extends Component {

    constructor(props) {
        super(props)

        this.state = {
            audio: "audiofile.mp3",
            heatpumpAudio: true,
            menuIsFloating: false
        }
    }

    static contextType = AppContext

    componentDidMount() {
      const { heatpumpAudio } = this.context

      var heatpump = document.getElementById("heatpumpAudioContainer");

      if(heatpumpAudio) {
        heatpump.play();
      } else {
        heatpump.pause();
      }

    }

    toggleHeatpumpAudio(e) {
        console.log(e.target.checked)

         const { heatpumpAudio, setHeatpumpAudio } = this.context;

         setHeatpumpAudio(e.target.checked);

         console.log("heatpumpAudio")
        console.log(heatpumpAudio)


      var heatpump = document.getElementById("heatpumpAudioContainer");

      if(e.target.checked) {
        heatpump.play();
      } else {
        heatpump.pause();
      }

    }

    adaptZoom(zoom) {
        this.props.action(zoom);
    }

    render() {

    const { heatpumpAudio, menuIsFloating } = this.context;

    const { t } = this.props;

    return (
        <div>
        <div className={!menuIsFloating? styles.fadeIn: styles.hide}>
          <div style={{ fontSize: '14px', fontFamily: 'Bosch-Bold', paddingTop: '4px'}}>
            {t('ui.heatpump')}
          </div>
          <div>
          <label className={ styles.switch } id="audio_switch" name="audio_switch">
            <input type="checkbox" checked={ heatpumpAudio } onChange={(e) => { this.toggleHeatpumpAudio(e)}} />
            <span className={ styles.slider + ' ' + styles.round } ></span>
          </label>

          </div>

        </div>

        <div className={menuIsFloating? styles.show: styles.hide} style={{color: '#FFF', fontFamily: 'Bosch-Bold', fontSize: '13px'}}>
                <div style={{textAlign: 'right', marginBottom: '10px', color: '#000', background: 'rgba(255,255,255,0.75)', padding: '10px', boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.5)'}}>
                {t('ui.navigation.heatpump')}
                </div>

                { /*<hr style={{height: '0px', marginTop: '5px', marginBottom: '12px', borderBottom: '1px solid #FFF', opacity: '1'}} />*/ }


                <label className={ styles.switch } id="audio_switch" name="audio_switch" style={{display: 'block', marginLeft: 'auto', marginRight: '0'}}>
                <input type="checkbox" checked={ heatpumpAudio } onChange={(e) => { this.toggleHeatpumpAudio(e)}} />
                <span className={ styles.slider + ' ' + styles.round } style={{boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.5)'}} ></span>
                </label>
        </div>
        </div>
    );
  }
}

export default withRouter(withTranslation()(ToggleAudio));
